import PropTypes from "prop-types";
import React from "react";
import ReportDefinitions from "../../../../common/config/ReportDefinitions";
import Report from "../../../common/components/Report";

const ItemOverviewReport = (props) => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.ITEM_OVERVIEW_V1_200.id,
        label: "Summary V1",
      },
      {
        value: ReportDefinitions.ITEM_OVERVIEW_V2_201.id,
        label: "Summary V2",
      },
      {
        value: ReportDefinitions.ITEM_OVERVIEW_DETAILS_200.id,
        label: "Item Details",
        loadFromTable: true,
        loadFromTableMessage: "app.warning.load.from.summary.report",
      },
    ]}
    className="no-stripe"
    {...props}
  />
);
export default ItemOverviewReport;

ItemOverviewReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
